module.exports = __webpack_public_path__ + "static/media/intelijj.12dd7832.svg";